// getHasEnoughBalanceForUnlock.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getMeBalance from '../selector/getMeBalance.js';
import getMessageUnlockPrice from '../selector/getMessageUnlockPrice.js';

/**
 * Select has enough balance for unlock by message id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} messageId - message id.
 * @return {boolean} should return true when user have enough balance to unlock message.
 */
const getHasEnoughBalanceForUnlock = createCachedSelector(
  state => getMeBalance(state),
  (state, messageId) => getMessageUnlockPrice(state, messageId),
  (balance, price) => balance >= price
)((state, messageId) => `getHasEnoughBalanceForUnlock:${messageId}`);

export default getHasEnoughBalanceForUnlock;
